export default class AuthenticationService {
    /**
     * The current authentication token.
     */
    private static ___authToken: string | null = null;

    /**
     * Get the current authentication token
     */
    getAuthToken(): string | null {
        if (AuthenticationService.___authToken !== null) {
            return AuthenticationService.___authToken;
        }

        const token = localStorage.getItem("pi2TokenV1");
        if (token !== null) {
            this.setAuthToken(token);
        } else {
            throw new Error("No token find");
        }
        return this.getAuthToken();
    }

    setAuthToken(token: string): void {
        localStorage.setItem("pi2TokenV1", token);
        AuthenticationService.___authToken = token;
    }

    logOut(): void {
        AuthenticationService.___authToken = null;
    }
}
